import axios from 'axios';
import { useOrderStore } from './stores/orderStore';

const API_URL = 'https://sweetdeliver.nl/wp-json/wc/v3';
const AJAX_URL = 'https://sweetdeliver.nl/wp-admin/admin-ajax.php';

const NONCE = window.sdData ? window.sdData.nonce : '';

// WooCommerce API credentials
const CONSUMER_KEY = 'ck_130a01aa83adf912e97d48ba3a52c2bd79acc97e';
const CONSUMER_SECRET = 'cs_69fb5ca64a65ea8486e4dbf993a4b5417384e997';

const api = axios.create({
  baseURL: API_URL,
  params: {
    consumer_key: CONSUMER_KEY,
    consumer_secret: CONSUMER_SECRET
  }
});


function getNonce() {
  return window.sdData?.nonce || '';
}

export default {
  async getProductsByCategory(categoryId) {
    try {
      const response = await api.get('/products', {
        params: {
          acf: true,
          category: categoryId,
          status: 'publish'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

  async addToCart(items) {
    try {
      const formattedItems = items.map(item => {
        return {
          product_id: item.product_id,
          quantity: item.quantity,

          // Add a unique key so WooCommerce doesn't merge them
          unique_box_id: `${Date.now()}_${Math.random()}`,

          // Delivery date
          delivery_date: item.verzenddatum || item.delivery_date,

          // Delivery address
          delivery_address: {
            first_name: item.delivery_address.name,
            last_name: '',
            company: '',
            address_1: item.delivery_address.address_1,
            address_2: item.delivery_address.address_2,
            city: item.delivery_address.city,
            state: '',
            postcode: item.delivery_address.postcode,
            country: item.delivery_address.country || 'NL'
          },

          // Flavors (smaken)
          smaken: item.smaken,

          // Card data (if any)
          card: item.card
            ? {
                id: item.card.id,
                naam: item.card['kaart-naam'] || item.card.name,
                tekst: item.card['kaart-tekst'] || item.card.text,
                ontvanger: item.card['kaart-ontvanger'] || item.delivery_address.name
              }
            : null
        };
      });

      const formData = new FormData();
      formData.append('action', 'sd_add_to_cart');
      formData.append('items', JSON.stringify(formattedItems));
      formData.append('security', NONCE);

      formData.append('security', getNonce());
      const response = await axios.post(AJAX_URL, formData);

      if (response.data.success) {
        return response.data;
      } else {
        throw new Error(
         response.data?.data?.message ||    // WordPress/Woo error
         response.data.message        ||    // any other shape
         'Failed to add items to cart'
       );
      }
    } catch (error) {
      console.error(
        'Error adding to cart:',
        error.response ? error.response.data : error.message
      );
      throw error;
    }
  },

  async updateCart(items) {
    try {
      const formData = new FormData();
      formData.append('action', 'sd_update_cart');
      formData.append('items', JSON.stringify(items));
      formData.append('security', NONCE);

      const response = await axios.post(AJAX_URL, formData);

      if (response.data.success) {
        const store = useOrderStore();
        store.clearItems();
        return response.data;
      } else {
        throw new Error(response.data.message || 'Failed to update cart');
      }
    } catch (error) {
      console.error(
        'Error updating cart:',
        error.response ? error.response.data : error.message
      );
      throw error;
    }
  },

  async getCart() {
    try {
      const formData = new FormData();
      formData.append('action', 'sd_get_cart');

      const response = await axios.post(AJAX_URL, formData);

      if (response.data.success) {
        return response.data.cart;
      } else {
        throw new Error(response.data.message || 'Failed to get cart');
      }
    } catch (error) {
      console.error('Error fetching cart:', error);
      throw error;
    }
  },

  async getProduct(productId) {
    try {
      const response = await api.get(`/products/${productId}`, {
        params: {
          acf: true,
          _fields: 'id,name,slug,price,description,images,acf,product_options,categories'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  },

  async getCategories() {
    try {
      const response = await api.get('/products/categories');
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },

  async getProductsByMultipleCategories(categoryIds) {
    try {
      const requests = categoryIds.map(categoryId => 
        api.get('/products', {
          params: {
            acf: true,
            category: categoryId,
            status: 'publish',
            per_page: 20
          }
        })
      );
      
      const responses = await Promise.all(requests);
      return responses.map(response => response.data);
    } catch (error) {
      console.error('Error fetching products from multiple categories:', error);
      throw error;
    }
  },

  async createOrder(orderData) {
    try {
      const response = await api.post('/orders', orderData);
      return response.data;
    } catch (error) {
      console.error('Error creating order:', error);
      throw error;
    }
  },

  async getOrder(orderId) {
    try {
      const response = await api.get(`/orders/${orderId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching order:', error);
      throw error;
    }
  }
};
